// extracted by mini-css-extract-plugin
export default {"bgLightGreen":"InvitationLinksTable_bgLightGreen__j1m8+"};